export const SystemVariablesEnum = {
  ColorPrimary: {
    key: '--c-primary',
  },
  ColorPrimaryBefore: {
    key: '--c-primary-before',
  },
  BorderColorPrimary: {
    key: '--bc-primary',
    isReflected: true,
  },
  BackgroundColorPrimary: {
    key: '--bg-primary',
    isReflected: true,
  },
  ColorPrimaryHover: {
    key: '--c-primary-hover',
  },
  BorderColorPrimaryHover: {
    key: '--bc-primary-hover',
    isReflected: true,
  },
  BackgroundColorPrimaryHover: {
    key: '--bg-primary-hover',
    isReflected: true,
  },
};
